import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { fetchUser } from './fetchUser';
import { TContext } from '../types/context';

export enum EProbeStatus {
  /** Монолит подтвердил авторизацию */
  Authenticated = 'authenticated',
  /** Монолит ответил, что пользователь не авторизован */
  Anonymous = 'anonymous',
  /** Проверка не состоялась, выводы делать нельзя */
  Failed = 'failed',
}

export type TUserAuthenticationProbe = {
  status: EProbeStatus;
  userId: number | null;
  statusCode: number | null;
  errorMessage: string | null;
};

const DEFAULT_SUBDOMAIN = 'www';

let isProbeStarted = false;

/**
 * Поддомен текущей страницы. Нужен там, где контекст сервиса не содержит custom
 */
function getSubdomain(): string {
  const [subdomain] = window.location.hostname.split('.');

  return subdomain || DEFAULT_SUBDOMAIN;
}

/* istanbul ignore next */
export function resetUserAuthenticationProbeForTests(): void {
  isProbeStarted = false;
}

/**
 * Один раз за загрузку страницы спрашивает у монолита, авторизован ли пользователь на самом деле.
 * Нужен, чтобы отличить протухшую сессию от других причин отказа публичных ручек.
 * Возвращает null, если проверка не выполнялась
 */
export async function probeUserAuthentication(
  context: TContext,
  subdomain?: string,
): Promise<TUserAuthenticationProbe | null> {
  if (typeof window === 'undefined' || isProbeStarted) {
    return null;
  }

  isProbeStarted = true;

  try {
    const user = await fetchUser(context, { subdomain: subdomain || getSubdomain(), throwOnError: true });

    return {
      status: user.isAuthenticated ? EProbeStatus.Authenticated : EProbeStatus.Anonymous,
      userId: user.userId || null,
      statusCode: 200,
      errorMessage: null,
    };
  } catch (error) {
    return {
      status: EProbeStatus.Failed,
      userId: null,
      statusCode: HttpBadStatusCodeError.isLike(error) ? error.statusCode : null,
      errorMessage: error instanceof Error ? error.message : null,
    };
  }
}
